<template>
  <div class="new-training-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <h2>培训管理</h2>
        <p class="page-desc">管理培训资料、考试题目和培训任务</p>
      </div>
      <div class="header-right">
        <el-button type="primary" @click="handleCreateTraining">
          <i class="el-icon-plus"></i>
          创建培训
        </el-button>
      </div>
    </div>

    <!-- Tab切换 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- 培训资料管理 -->
      <el-tab-pane label="培训资料" name="materials">
        <MaterialsManagement ref="materialsRef" @materials-selected="handleMaterialsSelected" />
      </el-tab-pane>

      <!-- 考试题目管理 -->
      <el-tab-pane label="考试管理" name="exams">
        <ExamManagement ref="examRef" @exam-selected="handleExamSelected" />
      </el-tab-pane>

      <!-- 培训组合管理 -->
      <el-tab-pane label="培训任务" name="trainings">
        <TrainingManagement
          ref="trainingRef"
          :selected-materials="selectedMaterials"
          :selected-exam="selectedExam"
          @training-created="handleTrainingCreated"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MaterialsManagement from "./components/MaterialsManagement.vue";
import ExamManagement from "./components/ExamManagement.vue";
import TrainingManagement from "./components/TrainingManagement.vue";

export default {
  name: "NewTraining",
  components: {
    MaterialsManagement,
    ExamManagement,
    TrainingManagement
  },
  data() {
    return {
      activeTab: "materials",
      selectedMaterials: null,
      selectedExam: null
    };
  },
  methods: {
    // Tab切换处理
    handleTabClick(tab) {
      this.activeTab = tab.name;
    },

    // 创建培训
    handleCreateTraining() {
      this.activeTab = "trainings";
      this.$nextTick(() => {
        this.$refs.trainingRef.showCreateDialog();
      });
    },

    // 资料选择处理
    handleMaterialsSelected(materials) {
      this.selectedMaterials = materials;
      console.log("选择的培训资料:", materials);
    },

    // 考试选择处理
    handleExamSelected(exam) {
      this.selectedExam = exam;
      console.log("选择的考试:", exam);
    },

    // 培训创建完成
    handleTrainingCreated(training) {
      console.log("培训创建完成:", training);
      this.$message.success("培训任务创建成功");
      // 刷新培训任务列表
      this.$refs.trainingRef.refreshList();
    }
  }
};
</script>

<style lang="less" scoped>
.new-training-container {
  padding: 20px;
  background: #f5f5f5;
  min-height: calc(100vh - 60px);

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .header-left {
      h2 {
        margin: 0 0 8px 0;
        color: #303133;
        font-size: 24px;
        font-weight: 600;
      }

      .page-desc {
        margin: 0;
        color: #909399;
        font-size: 14px;
      }
    }

    .header-right {
      .el-button {
        padding: 12px 24px;
        font-size: 14px;
        border-radius: 6px;
      }
    }
  }

  .el-tabs {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    ::v-deep .el-tabs__header {
      margin: 0;
      padding: 0 20px;
      border-bottom: 1px solid #e4e7ed;
    }

    ::v-deep .el-tabs__nav-wrap {
      padding: 0;
    }

    ::v-deep .el-tabs__item {
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 500;
    }

    ::v-deep .el-tabs__content {
      padding: 20px;
    }
  }
}
</style>
